import { jsx as _jsx } from "react/jsx-runtime";
import QrScanner from 'qr-scanner';
import { useLayoutEffect, useRef } from 'react';
import { CustomVideo } from './styles';
export const QrReader = ({ onSuccessScan }) => {
    const inputRef = useRef(null);
    const qrScannerRef = useRef();
    const handleScan = (result) => {
        onSuccessScan(result.data);
    };
    const closeQrReader = () => {
        if (!qrScannerRef.current)
            return;
        qrScannerRef.current.stop();
        qrScannerRef.current.destroy();
    };
    useLayoutEffect(() => {
        if (inputRef.current) {
            const qrScanner = new QrScanner(inputRef.current, (result) => handleScan(result), {});
            qrScannerRef.current = qrScanner;
            qrScannerRef.current.start();
        }
        return () => {
            closeQrReader();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return _jsx(CustomVideo, { ref: inputRef });
};
export default QrReader;
//# sourceMappingURL=qr-reader.js.map